import React, { useState } from 'react';
import './component-css/Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAboutUsClick = (e) => {
    e.preventDefault();
    window.open('/aboutus', '_self');
    closeMobileMenu();
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    window.open('/', '_self');
    closeMobileMenu();
  };

  const openDropdown = () => {
    setIsDropdownOpen(true);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const handleCategoryClick = () => {
    setIsDropdownOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      
      <div className="left-items">
        <Link to="/" onClick={closeMobileMenu}>
          <img src="/images/logo1.png" alt="1FUTURE logo" className="logo-image logo-1future" />
        </Link>
        <Link to="/" onClick={closeMobileMenu}>
          <img src="/images/logos2s1.png" alt="SKILL2SUSTAIN logo" className="logo-image logo-s2s" />
        </Link>
      </div>

      <div
        className={`menu-icon ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <ul className={`navbar-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        <li className="nav-item">
          <a href="/" className="nav-link" onClick={handleHomeClick}>Home</a>
        </li>

        <li className="nav-item">
          <a href="/" className="nav-link" onClick={handleAboutUsClick}>About Us</a>
        </li>

        <li className="nav-item">
          <a
            href="https://community.1future-platform.com/"
            target="_self"
            className="nav-link"
            onClick={closeMobileMenu}
          >
            Join Us
          </a>
        </li>

        <li className="nav-item">
          <a
            href="https://1future.feut.edu.al/"
            target="_blank"
            className="nav-link"
            onClick={closeMobileMenu}
          >
            1Future Website
          </a>
        </li>
        <li className="nav-item">
          <a
            href="https://skill2sustain.uns.ac.rs/"
            target="_blank"
            className="nav-link"
            onClick={closeMobileMenu}
          >
            Skill2Sustain Website
          </a>
        </li>

        {/* Learning Materials Dropdown */}
        <li
          className="nav-item dropdown"
          onMouseEnter={openDropdown}
          onMouseLeave={closeDropdown}
        >
          <span className="nav-link dropdown-toggle" onClick={toggleDropdown}>
            Learning Materials
          </span>

          {isDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <Link
                  to="/learning-materials/risk-management"
                  className="dropdown-item"
                  onClick={handleCategoryClick}
                >
                  Risk Management
                </Link>
              </li>

              <li>
                <Link
                  to="/learning-materials/energy-efficiency"
                  className="dropdown-item"
                  onClick={handleCategoryClick}
                >
                  Energy Efficiency
                </Link>
              </li>

              <li>
                <Link
                  to="/learning-materials/urban-resilience"
                  className="dropdown-item"
                  onClick={handleCategoryClick}
                >
                  Urban Resilience
                </Link>
              </li>

              <li>
                <Link
                  to="/learning-materials/sustainable-construction"
                  className="dropdown-item"
                  onClick={handleCategoryClick}
                >
                  Sustainable Construction
                </Link>
              </li>

              <li>
                <Link
                  to="/learning-materials/economics-and-management"
                  className="dropdown-item"
                  onClick={handleCategoryClick}
                >
                  Economics and Management
                </Link>
              </li>
            </ul>
          )}
        </li>

        <li className="nav-item">
          <Link to="/resources" className="nav-link" onClick={closeMobileMenu}>
            Tutorials
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
